/*
* @Author: LiuMouLiang
* @Date:   2023-04-04 16:22:03
* @class:  特殊产品控制
*/
import {
    getObjVal,
    typeOf,
    _for,
    _getStr,
    _toNumber,
    isEmptyObject,
} from 'tools';
import {
    toJson,
    trace,
} from './base';
import {
    getInvoicePageSettings,
} from './works';

// 全局控制
export const globalControlConfig = {
    productId: '',
    salesType: -1, //0-网销，1-经代导单，2-经代在线投保，3-网销转经代，5-互联网产品，6-经代产品
    productType: 0, // data-models
    isSpecialCustomizedProduct: false, // 是否定制产品
    isOcrAuthorizationBookList: false, // 是否验证OCR_投保声明盖章影像件
    isHighSkyInsuredPeople: false, //是否是高空被投保人
    isInvoiceApplyTaxTel: false, // 是否展示申请发票页面中普票的联系电话 == 普票+专票
    /* 新单页面配置 */
    insurePageConfig: {
        isJumpWritePage: false, //是否跳转至投保页面
        isNewConfigType: false, //是否是产品新配置类型
        isRepeatPremiumRateWithFactors: false, //是否去重佣金率 （需和扩展责任进行关联）
    },
    /* 投保新单 */
    // isRealNameProduct: true, // 是否需要代理人实名认证
    notInsuredPeopleNum: false, // 不显示产品不存在投保人数
    notInsuredAgeRange: false, // 不显示或校验投保对象 +部分CPS产品
    notInsuredCareer: false, // 不显示或校验职业(目前只有建工险)+ 部分CPS产品
    calculateNeedInsureHouseAddress: false, //营业执照登记住所必填isSupportPcConservation ++ 地区加费
    /* 老的前端逻辑写到太乱，兼容老逻辑配置 */
    oldCompatibleConfig: {
    },
    // 老的前端控制信息
    frontControlInfo: {
        multiPlan: 0, //多保障计划
        multiPlanAndMultiProfession: 0, //开放式多计划
        multiPlanSupportSameProfession: 0, //同一计划可多职业但须同类别
        multiPlanSupportSameProfessionAddMultiPlan: 0, //多计划职业类型可相同 如80144 80129
        multiProfession: 0, //多职业投保
        ageCheckType: '',
    },
    /* 全局临时配置-需求抛弃 */
    globalTempUpConfig: {
        BQisNewObj_NOT_replace: true, //保全的新增职业的替换职业-不需要了隐藏
    },
    /* 建工险 */
    isInsuranceConstructionProduct: false, //是否是建工险产品
    insuranceConstructionProductData: { //建工险产品特殊控制
        hasConstructionInfoProjectCosts: false, //建工，是否用工程信息中的造价来计算保费
        isUseConstructionAddressData: false, //是否使用额外的工程地址数据 - 目前存在只有省  == 现在又不要了
        onlyProvinceAddressData: false, //建工地址数据只有省份 - 与isUseConstructionAddressData进行关联
    },
    isNeedMailInsuranceForm: false, // 是否需要邮寄盖章投保单
    /* 属于详情页的特殊配置 */
    detailPageConfig: {
        factorRateAll_showDescAllStr: false, // 产品详情页扩展责任不按范围全部展示
    },
    /* 属于报价页的特殊配置 */
    quotePageConfig: {
        isGetQuoteHideFast: false, //报价页是否隐藏职业大类
        useDetail_durationDesc: false, //使用详情数据-保障期限描述
    },
    /* 属于发票配置的特殊配置 */
    invoicePageConfig: {
    },
    /* 保全页面配置 */
    bqPageConfig: {
        isRefuseIncludeJob: false, //拒保职业是否拦截 (拒保职业是否覆盖在保订单在保职业保全)
    },
    /* 保全 */
    supportAddJob: false, // 是否支持新增职业
};

//根据产品id判断是否在列表中
export const _includesToProductId = function(list=[], productId = globalControlConfig.productId){
    if(!productId || !list.length) return false;
    return list.includes(_getStr(productId));
};

export const set_globalControlConfig = function(params, info = ''){
    _for(params, (el, key)=>{
        if(key === 'productId'){
            globalControlConfig.productId = _getStr(el);
        }else{
            globalControlConfig[key] = el;
        };
    });
    trace('设置全局控制器 === ', info , globalControlConfig);
    return globalControlConfig;
};

//验证OCR_投保声明盖章影像件 -2025-12-12 不需要了，改调用接口，然后通过this.productSpecialConfig.isCheckOcr获取
// const is_control_OCR_authorizationBookList = control_OCR_authorizationBookList(productId)
// export const control_OCR_authorizationBookList = function(productId, data){
//     const isTrue = _includesToProductId([
//         '80140',
//         '80202',
//         '80204',
//         '80205',
//         '80275'
//     ], productId || globalControlConfig.productId);
//     const name = 'isOcrAuthorizationBookList';

//     if(data) {
//         data[name] = isTrue;
//     }else{
//         set_globalControlConfig({
//             [name]: isTrue,
//         }, '验证OCR_投保声明盖章影像件');
//     };
//     return isTrue;
// };

// 控制申请发票页面中普票的联系电话展示
export const control_invoice_apply_taxTel = function(productId){
    const res = _includesToProductId([
        '80140',
        '336',
        '70101',
        '70102',
    ], productId || globalControlConfig.productId);
    const config = {
        isInvoiceApplyTaxTel: res,
    };
    if(productId) {
        config['productId'] = productId
    }
    set_globalControlConfig(config, '控制申请发票页面中普票的联系电话展示');
    return res;
};

// 控制 - 建工险产品特殊配置
export const control_insuranceConstructionProductData = function(data, res){
    const datakey = 'insuranceConstructionProductData';
    const insuranceConstructionProductData = Object.assign(globalControlConfig[datakey], data);

    if(res) {
        res[datakey] = insuranceConstructionProductData;
    }else{
        set_globalControlConfig({
            [datakey]: insuranceConstructionProductData,
        }, '控制-建工险产品特殊配置');
    };

    return insuranceConstructionProductData;
};

// 控制 - 是否是建工险产品
// globalControlConfig.isInsuranceConstructionProduct
export const control_isInsuranceConstructionProduct = function(productId, data){
    const isTrue = _includesToProductId([
        '80137',
        '80138',
        '80156',
        '80180',
        '80221',
        '80218',
        '80237',
        '80297'
    ], productId);
    const name = 'isInsuranceConstructionProduct';
    const hasConstructionInfoProjectCosts = _includesToProductId([
        '80156',
    ], productId);
    const isUseConstructionAddressData = _includesToProductId([
        // '80156',
    ], productId);

    control_insuranceConstructionProductData({
        hasConstructionInfoProjectCosts,
        isUseConstructionAddressData,
    }, data);

    if(data) {
        data[name] = isTrue;
    }else{
        set_globalControlConfig({
            [name]: isTrue,
        }, '控制-是否是建工险产品');
    };
    return isTrue;
};

// 控制 - 不显示或校验产品的投保人数
//globalControlConfig.notInsuredPeopleNum
export const control_notInsuredPeopleNum = function(productId, data){
    let isTrue = _includesToProductId([
        '80165',
        '80160',
        '80162',
    ], productId || globalControlConfig.productId);
    if(!isTrue) {
        isTrue = control_isInsuranceConstructionProduct(productId, data);
    }
    const name = 'notInsuredPeopleNum';
    if(data) {
        data[name] = isTrue;
    }else{
        set_globalControlConfig({
            [name]: isTrue,
        }, '控制-不显示或校验产品的投保人数');
    };
    return isTrue;
};
// 控制 - 不显示或校验投保对象
//globalControlConfig.notInsuredAgeRange
export const control_notInsuredAgeRange = function(productId, data){
    let isTrue = _includesToProductId([
        '80165',
        '80160',
        '80162',
    ], productId || globalControlConfig.productId);

    const name = 'notInsuredAgeRange';
    if(data) {
        data[name] = isTrue;
    }else{
        set_globalControlConfig({
            [name]: isTrue,
        }, '控制不显示或校验投保对象');
    };
    return isTrue;
};
// 控制 - 不显示或校验职业
//globalControlConfig.notInsuredAgeRange
export const control_notInsuredCareer = function(productId, data){
    let isTrue = _includesToProductId([
        '80165',
        '80160',
        '80162',
    ], productId || globalControlConfig.productId);
    if(!isTrue) {
        isTrue = control_isInsuranceConstructionProduct(productId, data);
    }
    const name = 'notInsuredCareer';
    if(data) {
        data[name] = isTrue;
    }else{
        set_globalControlConfig({
            [name]: isTrue,
        }, '控制不显示或校验职业');
    };
    return isTrue;
};

// 控制 - 营业执照登记住所必填
//globalControlConfig.calculateNeedInsureHouseAddress
export const control_calculateNeedInsureHouseAddress = function(productId, data){
    let isTrue = _includesToProductId([
        '103',
        '80205',
        '80275',
    ], productId || globalControlConfig.productId);
    const name = 'calculateNeedInsureHouseAddress';
    if(data) {
        data[name] = isTrue;
    }else{
        set_globalControlConfig({
            [name]: isTrue,
        }, '控制-营业执照登记住所必填');
    };
    return isTrue;
};

// 控制 - 属于详情页的特殊配置
//quotePageConfig
export const control_detailPageConfig = function(productId, data){
    const datakey = 'detailPageConfig';
    const factorRateAll_showDescAllStr = _includesToProductId([
        '80199',
        '204',
        '205',
    ], productId);

    const detailPageConfig = Object.assign(globalControlConfig[datakey], {
        factorRateAll_showDescAllStr,
    });
    if(data) {
        data[datakey] = detailPageConfig;
    }else{
        set_globalControlConfig({
            [datakey]: detailPageConfig,
        }, '控制-属于详情页的特殊配置');
    };
    return detailPageConfig;
};

// 控制 - 属于报价页的特殊配置
//quotePageConfig
export const control_quotePageConfig = function(productId, data){
    const datakey = 'quotePageConfig';
    const useDetail_durationDesc = _includesToProductId([
        '80156',
        '80237'
    ], productId);

    const quotePageConfig = Object.assign(globalControlConfig[datakey], {
        useDetail_durationDesc,
    });
    if(data) {
        data[datakey] = quotePageConfig;
    }else{
        set_globalControlConfig({
            [datakey]: quotePageConfig,
        }, '控制-属于报价页的特殊配置');
    };
    return quotePageConfig;
};

// 控制 - 属于发票配置的特殊配置
export const control_invoicePageConfig = function(productMsg, data){
    const datakey = 'invoicePageConfig';
    const invoicePageConfig = getInvoicePageSettings(productMsg);

    if(data) {
        data[datakey] = invoicePageConfig;
    }else{
        set_globalControlConfig({
            [datakey]: invoicePageConfig,
        }, '控制-属于发票配置的特殊配置');
    };

    return invoicePageConfig;
};

// 设置新单页面配置
export const set_insurePageConfig = function(config, data){
    const datakey = 'insurePageConfig';
    const productId = data && data.productId;

    const insurePageConfig = Object.assign(globalControlConfig[datakey], config);
    // 是否去重佣金率
    insurePageConfig['isRepeatPremiumRateWithFactors'] = _includesToProductId([
        '80210',
    ], productId);
    if(data) {
        data[datakey] = insurePageConfig;
    }else{
        set_globalControlConfig({
            [datakey]: insurePageConfig,
        }, '设置新单页面配置');
    };
    return insurePageConfig;
};

// 设置保全页面配置
export const set_bqPageConfig = function(config, data){
    const datakey = 'bqPageConfig';

    const bqPageConfig = Object.assign(globalControlConfig[datakey], config);
    if(data) {
        data[datakey] = bqPageConfig;
    }else{
        set_globalControlConfig({
            [datakey]: bqPageConfig,
        }, '设置保全页面配置');
    };
    return bqPageConfig;
};

// 控制 - 是否需要邮寄盖章投保单
export const needMailInsuranceForm = function(productId, data){
    let isTrue = _includesToProductId([
        '338',
        '80190',
        '80230',
        '80281',
        '80302',
        '80303'
        // '80237',
        // '80231',
        // '80232',
    ], productId || globalControlConfig.productId);

    const name = 'isNeedMailInsuranceForm';
    if(data) {
        data[name] = isTrue;
    }else{
        set_globalControlConfig({
            [name]: isTrue,
        }, '控制 - 是否需要邮寄盖章投保单');
    };
    return isTrue;
};

// 老的前端控制信息
export const set_frontControlInfo = function(config, data){
    const datakey = 'frontControlInfo';
    let frontControlInfo = globalControlConfig[datakey];
    _for(frontControlInfo , (info,key) => {
        frontControlInfo[key] = config[key] || info;
    });
    if(data) {
        data[datakey] = frontControlInfo;
    }else{
        set_globalControlConfig({
            [datakey]: frontControlInfo,
        }, '设置老的前端控制信息');
    };
    return frontControlInfo;
};


export const controlConfig_commissionRate = {
    '80212': {
        label: '保障方案',
        planCodeSetStr: {
            '1': '轻享版',
            '2': '尊享版',
        },
    }
};



// WEBPACK FOOTER //
// ./src/libs/util/control.js